import ExternalCalendarList from "externalCalendar/ExternalCalendarList";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const externalCalendarRoute: RouteObject = {
  path: "externalcalendar",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ExternalCalendarList,
  }]
};